module.exports = __webpack_public_path__ + "img/3405ab5.jpg";